import {ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {CompositeFilterDescriptor} from '@progress/kendo-data-query';
import {GridFormComponent} from '../grid-form';
import {ApiService, LanguagesService, MessageService, StateService} from '../../../core';
import {TreeListComponent} from '@progress/kendo-angular-treelist';
import {take} from 'rxjs/operators';

@Component({
  selector: 'gc-tree-grid-form',
  templateUrl: './tree-grid-form.component.html',
  styleUrls: ['./tree-grid-form.component.css']
})

export class TreeGridFormComponent extends GridFormComponent implements OnInit {

  constructor(protected api: ApiService, protected message: MessageService,
              public lang: LanguagesService, protected state: StateService, protected cd: ChangeDetectorRef,
              protected el: ElementRef, protected ngZone: NgZone
  ) {
    super(api, message, lang, state, cd, el, ngZone);
  }

  @Input() expandField = 'name';
  @Input() idField = 'id';
  @Input() parentIdField = 'parent';
  @ViewChild('grid') tree: TreeListComponent;

  public treeGridSelectedKeys = [];
  ngOnInit(): void {

  }

  load(): void {
    super.load(() => {
      this.expandEvent(null);
    });
  }

  save(serial: number = null, OnSaved: (success: number, message: string) => void = null): void {
    super.save(serial, (success: number, message: string) => {
      this.data = [... this.data];
      if (OnSaved) {
        OnSaved(success, message);
      }
    });
  }

  public resize(): void {
    super.resize();
    this.expandEvent(null);
  }

  public filterChange(event: CompositeFilterDescriptor): void {

  }

  public sortChange(event): void{

  }

  public expandEvent(event): void {
    // this.tree.focusCell(1, 2);
    this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
      this.tree.autoFitColumn(this.tree.columns.first);
    });
  }

  public selectionChange(): void {
    // Convert selected keys
    this.cancel();

    this.selectedKeys = [];
    this.treeGridSelectedKeys.forEach(rec => {
      if (rec && rec.itemKey) {
        this.selectedKeys.push(rec.itemKey);
      }
    });
  }

}
